/**
 * Feed / `state.campaign` already shows the registration target while lastSet / on-air
 * queue still plays the outgoing playlist (or peek diverges). Soft-defer must rematerialize.
 *
 * Also used by the periodic desync watchdog: pass `nextId === uiId` (Feed as desired target)
 * when no fresh CAMPAIGN_UPDATE is available — field stuck after hash-stable polls (#1636).
 */
export function isFeedAheadOfMaterialization(options: {
  playingSomething: boolean
  uiId: string | null
  nextId: string | null
  loadedId: string | null
  onAirSeq: string
  peekSeq: string
}): boolean {
  return (
    options.playingSomething
    && options.nextId != null
    && options.uiId === options.nextId
    && (
      options.loadedId == null
      || options.loadedId !== options.nextId
      || options.onAirSeq !== options.peekSeq
    )
  )
}

/**
 * Soft-defer owns cutover while a deferred root or pending-swap overlay is armed.
 * Rematerialize must not clear those and apply without head-gated await (Slimbox
 * Campanha→Publicar: ~100s lag from heal/steal + forceAssetReload).
 */
export function shouldSkipFeedAheadRematerializeWhileSoftDefer(options: {
  deferredRegistrationPlaybackRoot: unknown | null
  pendingPlaylistSwap: unknown | null
}): boolean {
  return (
    options.deferredRegistrationPlaybackRoot != null
    || options.pendingPlaylistSwap != null
  )
}

/**
 * How often to re-check Feed vs lastSet/on-air when registration hash is stable
 * (no further {@code CAMPAIGN_UPDATE}). Shorter than soft-defer starvation (120s);
 * long enough to avoid rematerialize thrash while soft-defer owns cutover.
 */
export const FEED_MATERIALIZATION_DESYNC_HEAL_INTERVAL_MS = 15_000
